<template>
  <div class="submit_body" @click="closeStatus">
    <el-input
      ref="targetInput"
      v-model="speechForm.content"
      resize="none"
      :autosize="{ minRows: 4 }"
      type="textarea"
      placeholder="请输入内容"
    />

    <div class="image_cover_box">
      <!-- 普通图片 -->
      <div class="upload_item">
        <div class="upload_inner">
          <div
            v-for="(item, index) in speechForm.images"
            :key="index"
            class="pr"
          >
            <img class="image_cover" :src="item.url" alt="" />
            <div class="zhezhaoceng6">
              <el-icon
                class="mr15 can"
                @click.stop="handlePictureCardPreview(item)"
                :size="24"
              >
                <ZoomIn color="#ffffff" />
              </el-icon>
              <el-icon class="can" @click.stop="handleRemove(index)" :size="24">
                <Delete color="#ffffff" />
              </el-icon>
            </div>
          </div>
          <el-upload
            v-if="!speechForm.images.length"
            action="https://api.i-vce.com/teacher/common/upload"
            list-type="picture-card"
            :on-success="handleImgSuccess"
            :headers="headers"
            :show-file-list="false"
            :before-upload="beforeUpload"
            accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PNG,.GIF"
            :limit="1"
          >
            <img
              class="w100 block"
              src="@/assets/img/qiyouCommunityV2/upload_img.png"
              alt=""
            />
          </el-upload>
        </div>
      </div>

      <!-- 一言一策 -->
      <div class="upload_item">
        <div class="upload_inner">
          <div
            v-for="(item, index) in speechForm.oneWordImages"
            :key="index"
            class="pr"
          >
            <img class="image_cover" :src="item.url" alt="" />
            <div class="zhezhaoceng6">
              <el-icon
                class="mr15 can"
                @click.stop="handlePictureCardPreview(item)"
                :size="24"
              >
                <ZoomIn color="#ffffff" />
              </el-icon>
              <el-icon
                class="can"
                @click.stop="handleOneWordRemove(index)"
                :size="24"
              >
                <Delete color="#ffffff" />
              </el-icon>
            </div>
          </div>
          <el-upload
            v-if="!speechForm.oneWordImages.length"
            action="https://api.i-vce.com/teacher/common/upload"
            list-type="picture-card"
            :on-success="handleOneWordImgSuccess"
            :headers="headers"
            :show-file-list="false"
            :before-upload="beforeUpload"
            accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PNG,.GIF"
            :limit="1"
          >
            <div class="upload_img_wrapper">
              <img
                class="w100 block"
                src="@/assets/img/qiyouCommunityV2/yyyc.png"
                alt=""
              />
            </div>
          </el-upload>
        </div>
      </div>
    </div>

    <el-dialog v-model="dialogVisible" title="" width="40%">
      <img style="width: 100%" :src="dialogImageUrl" alt="" />
    </el-dialog>

    <div class="flex ai_c jc_b mt15">
      <div class="handle_more">
        <Emoji
          v-if="emojiStatus"
          id="public"
          style="top: auto; bottom: 30px"
          @changeInput="changeInput"
        />
        <div class="" @click.stop="changeEmojiStatus">
          <img
            class="icon_emoji"
            src="@/assets/img/qiyouCommunityV2/icon_emoji.png"
            alt=""
          />
          表情
        </div>
        <!-- <el-upload
          action="https://api.i-vce.com/api/common/upload"
          :on-success="handleImgSuccess1"
          :show-file-list="false"
          :headers="headers"
          :before-upload="beforeUpload"
          accept=".jpg,.jpeg,.png,.gif,.JPG,.JPEG,.PNG,.GIF"
          :on-progress="onProgress"
        >
          <div class="flex ai_c">
            <img
              class="icon_img"
              src="@/assets/img/qiyouCommunityV2/icon_photo.png"
              alt=""
            />
            图片
          </div>
        </el-upload> -->
        <div v-if="topicShow" class="pr">
          <!-- 话题选择器 -->
          <!-- <div v-if="topicStatus" class="topic_list">
            <div class="head" @click.stop="">
              <div class="mb5">选择话题</div>
              <el-input
                v-model="topicSearch"
                class="topic_input"
                clearable
                placeholder="请输入话题名称"
                @input="getTopicList"
              />
            </div>
            <div class="topic_cells overflow_y">
              <div
                v-if="customTopicStatus"
                class="topic_cell"
                @click="chooseTopic(topicSearch)"
              >
                <div style="padding-right: 60px">
                  <img src="@/assets/img/qiyouCommunity/icon_logo.png" alt="" />
                  <span>#{{ topicSearch }}#</span>
                  <div class="btn">添加话题</div>
                </div>
              </div>
              <div
                v-for="(item, index) in topicList"
                :key="index"
                class="topic_cell"
                @click="chooseTopic(item.name)"
              >
                <div>
                  <img :src="item.image" alt="" />
                  <span>#{{ item.name }}#</span>
                </div>
              </div>
            </div>
          </div> -->
          <!-- <div class="flex ai_c" @click.stop="changeTopicStatus">
            <img
              class="icon_topic"
              src="@/assets/img/qiyouCommunityV2/icon_topic.png"
              alt=""
            />
            话题
          </div> -->
        </div>
        <div class="pr">
          <!-- 品种选择器 -->
          <!-- <div v-if="categoryStatus" class="category_list">
            <div class="head" @click.stop="">
              <div class="mb5">选择品种</div>
              <el-input
                v-model="topicSearch"
                class="category_input"
                clearable
                placeholder="请输入品种名称"
                @input="customSearch"
              />
            </div>
            <div class="category_cells overflow_y">
              <div
                v-for="(item, index) in oneList"
                :key="index"
                class="category_cell"
                @click="chooseCategory(item.name)"
              >
                <div>
                  <span>{{ item.name }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="flex ai_c" @click.stop="changeCategoryStatus">
            <img
              class="icon_pinzhong"
              src="@/assets/img/qiyouCommunityV2/icon_pinzhong.png"
              alt=""
            />
            品种
          </div> -->
        </div>
      </div>
      <!-- <div class="btn1" @click="submit">发布</div> -->
    </div>

    <div class="flex ai_c jc_b mt15">
      <div>
        <el-checkbox v-model="speechForm.checked">同步到期友社区</el-checkbox>
      </div>
      <div class="btn1" @click="submit">发布</div>
    </div>

    <!-- <div class="flex ai_c jc_b mt15" style="height: 28px">
      <div class="flex ai_c">
        <div v-show="!speechForm.is_qa" class="switch_text">
          <el-switch
            :value="speechForm.open_gift"
            active-color="#4571e7"
            inactive-color="#DCDFE6"
            @change="changeOpenGift"
          />
          <span>开启打赏</span>
        </div>

        <div v-show="!speechForm.open_gift" class="switch_text">
          <el-switch
            :value="speechForm.is_qa"
            active-color="#4571e7"
            inactive-color="#DCDFE6"
            @change="changeIsQa"
          />
          <span>设为问答</span>
        </div>

        <div v-show="speechForm.is_qa" class="input_number">
          <span>悬赏</span>
          <el-input-number
            v-model="speechForm.money"
            :step-strictly="true"
            :min="0"
            size="mini"
            style="width: 100px"
          />
        </div>
      </div>
    </div> -->
    <!-- <TipMessage ref="tipMessage" /> -->
  </div>
</template>

<script>
import { Debounce } from "@/utils/debounce";
import Emoji from "@/components/emoji.vue";
export default {
  components: {
    Emoji,
  },
  props: {
    title: {
      type: String,
      default: "",
    },
    content: {
      type: String,
      default: "",
    },
    showClose: {
      type: Boolean,
      default: false,
    },
    topicShow: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      speechForm: {
        images: [
          // {
          //   url: "https://i-vce.oss-cn-shanghai.aliyuncs.com/push/chat/20250429/1745907754606.png",
          // },
        ],
        oneWordImages: [], // 一言一策图片
        content: "",
        checked: true,
        // open_gift: false,
        // is_qa: false,
        // money: 0,
        // category_id: 0,
      },
      category_name: "",
      headers: {},
      dialogImageUrl: "",
      dialogVisible: false,
      emojiStatus: false, // 表情显示状态
      topicSearch: "", // 话题搜索词
      topicList: [], // 话题列表
      topicStatus: false, // 话题列表显示状态
      customTopicStatus: false,
      categoryStatus: false, // 品种列表显示状态
      oneListOrigin: [],
      oneList: [],
      vMoney: 0,
      giftTip: "",
    };
  },
  watch: {
    content(e) {
      this.speechForm.content = e;
    },
  },
  mounted() {
    const that = this;
    this.headers = {
      token: localStorage.getItem("tokenReload"),
    };
    // this.getTopicList();
    // this.getBaseInfo();
    // this.getBaseInfo1();
    // this.getTaskInfo();

    document.addEventListener("paste", function (e) {
      // console.warn('e', e)
      if (!(e.clipboardData && e.clipboardData.items)) {
        return;
      }
      for (let i = 0, len = e.clipboardData.items.length; i < len; i++) {
        const item = e.clipboardData.items[i];

        if (item.kind === "string") {
          item.getAsString(function (str) {
            // console.log('str', str)
            // str 是获取到的字符串
          });
        } else if (item.kind === "file") {
          const reader = new FileReader(); // 实例化文件读取对象
          reader.readAsDataURL(item.getAsFile());
          reader.onload = (e) => {
            // 文件读取成功完成时触发
            const dataURL = e.target.result; // 获得文件读取成功后的DataURL,也就是base64编码
            // console.log('dataURL', dataURL)
            that.uploadBase64(dataURL);
          };
          // pasteFile就是获取到的文件
        }
      }
    });
  },
  methods: {
    async uploadBase64(dataURL) {
      const res = await request.post("/api/common/uploadBase64", {
        pic: dataURL,
      });
      this.speechForm.images.push({
        url: res.data.url,
      });
      // console.log('-------uploadBase64', res)
    },
    async getBaseInfo1() {
      const res = await request.post("/api/qi_you/getBaseInfo");
      this.giftTip = res.data.gift_tip;
    },
    changeSubmitType(type) {
      if (type === 1) {
        // 切换为普通模式
        this.changeIsQa(false);
      } else {
        // 切换为问答模式
        this.changeIsQa(true);
      }
    },
    async getTaskInfo() {
      const res = await request.post("/api/task/getTaskInfo", {
        type: 12,
      });
      this.vMoney = res.data.money;
    },
    async getBaseInfo() {
      const res = await request.post("/api/bbas/getBaseInfo");
      this.oneListOrigin = res.data.oneList;
      this.oneList = res.data.oneList;
    },
    customSearch(e) {
      this.oneList = this.oneListOrigin.filter((item) =>
        item.bbas_match_name.includes(e)
      );
    },
    changeOpenGift(e) {
      this.speechForm.open_gift = e;
      if (e) {
        this.speechForm.is_qa = false;
        this.speechForm.money = 0;
      }
    },
    changeIsQa(e) {
      this.speechForm.is_qa = e;
      if (e) {
        this.speechForm.open_gift = false;
      }
    },
    closePopup() {
      this.$emit("close");
    },
    closeStatus() {
      this.emojiStatus = false;
      this.topicStatus = false;
      this.categoryStatus = false;
    },
    // 获取话题列表
    async getTopicList() {
      const res = await request.post("/api/qi_you/getTopicList", {
        page: 1,
        limit: 100,
        search: this.topicSearch,
      });
      const topicList = res.data.data;
      this.topicList = topicList;

      if (this.topicSearch) {
        this.customTopicStatus = true;
        if (this.topicList.length) {
          let num = 0;
          for (const item of topicList) {
            if (item.name === this.topicSearch) {
              num++;
            }
          }
          this.customTopicStatus = !num;
        } else {
          this.customTopicStatus = true;
        }
      } else {
        this.customTopicStatus = false;
      }
    },
    // 插入表情
    changeInput(e) {
      const element = this.$refs.targetInput.$refs.textarea;
      const cursorPosition = element.selectionStart;
      const beforeText = element.value.substring(0, cursorPosition);
      const afterText = element.value.substring(cursorPosition);
      const finalText = beforeText + e + afterText;
      this.emojiStatus = false;
      this.speechForm.content = finalText;
    },
    // 插入话题
    chooseTopic(e) {
      const element = this.$refs.targetInput.$refs.textarea;
      const cursorPosition = element.selectionStart;
      const beforeText = element.value.substring(0, cursorPosition);
      const afterText = element.value.substring(cursorPosition);
      const finalText = beforeText + "#" + e + "#" + afterText;
      this.topicStatus = false;
      this.speechForm.content = finalText;
    },
    // 插入品种
    chooseCategory(e) {
      const element = this.$refs.targetInput.$refs.textarea;
      const cursorPosition = element.selectionStart;
      const beforeText = element.value.substring(0, cursorPosition);
      const afterText = element.value.substring(cursorPosition);
      const finalText = beforeText + "【" + e + "】" + afterText;
      this.categoryStatus = false;
      this.speechForm.content = finalText;
    },
    // chooseCategory (item) {
    //   this.category_name = item.name
    //   this.speechForm.category_id = item.id
    // },
    // emoji选择列表展示状态更改
    changeEmojiStatus() {
      this.emojiStatus = !this.emojiStatus;

      this.topicStatus = false;
      this.categoryStatus = false;
    },
    changeTopicStatus() {
      this.topicStatus = !this.topicStatus;

      this.emojiStatus = false;
      this.categoryStatus = false;
    },
    changeCategoryStatus() {
      this.categoryStatus = !this.categoryStatus;

      this.emojiStatus = false;
      this.topicStatus = false;
    },
    handleImgSuccess(e) {
      this.speechForm.images.push({
        url: e.data.fullurl,
      });
    },
    // 一言一策图片上传成功
    handleOneWordImgSuccess(e) {
      this.speechForm.oneWordImages.push({
        url: e.data.fullurl,
      });
    },
    // 删除一言一策图片
    handleOneWordRemove(index) {
      this.speechForm.oneWordImages.splice(index, 1);
    },
    handleImgSuccess1(e) {
      this.speechForm.images.push({
        url: e.data.fullurl,
      });
    },
    onProgress(event, file, fileList) {
      if (event.percent === 100) {
        // console.warn('上传成功')
        this.imgUping = false;
      } else {
        // console.log('上传中,进度：', event.percent + '%')
        this.imgUping = true;
      }
    },
    beforeUpload(file) {
      // const FILE_NAME = file.name
      // console.error('@@@', FILE_NAME.substring(FILE_NAME.lastIndexOf('.')))
      // if (FILE_NAME.substring(FILE_NAME.lastIndexOf('.')) !== '.xls' && FILE_NAME.substring(FILE_NAME.lastIndexOf('.')) !== '.xlsx') {
      //   this.$message.warning('请上传正确格式的图片')
      //   return false
      // }
      const isLt1M = file.size / 1024 / 1024 < 30;
      if (isLt1M) {
        this.file = file;
        return true;
      }
      this.$message.warning("请上传不超过30M的文件");
      return false;
    },
    handleRemove(index) {
      this.speechForm.images.splice(index, 1);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      // console.log(file)
    },
    submit: Debounce(async function () {
      const obj = { ...this.speechForm };

      if (!obj.content && !obj.images.length && !obj.oneWordImages.length) {
        this.$message.error("说点什么吧");
        return false;
      }
      if (this.imgUping) {
        this.$message.error("图片正在上传中，请稍后");
        return false;
      }
      this.$parent.privateChatSend(obj);
      // const res = await request.post("/api/qi_you/addInfo", obj);
      // this.$message.success(res.msg);
      // this.$addSiteStatistics(this, { type: obj.is_qa ? 191 : 190 });
      // this.$refs.tipMessage.open(res.data.task);
      // this.speechForm = {
      //   images: [],
      //   content: "",
      //   open_gift: false,
      //   is_qa: false,
      //   money: 0,
      //   category_id: 0,
      // };
      // this.category_name = "";
      // this.list = [];

      // this.$emit("resultHandle");
      // this.$emit("close");
    }),
    clearSubmitSpeechForm() {
      this.speechForm.images = [];
      this.speechForm.oneWordImages = [];
      this.speechForm.content = "";
    },
    async getSendInfo() {
      // const obj = { ...this.speechForm };
      return await this.speechForm;
    },
  },
};
</script>

<style scoped>
.submit_body {
  box-sizing: border-box;
  padding: 16px;
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 10px;
}

.submit_body .head_cell {
  position: relative;
  display: flex;
  align-items: center;
}

.submit_body .title {
  font-size: 18px;
  color: #414141;
  margin-bottom: 15px;
}

.submit_body .icon_close {
  cursor: pointer;
  position: absolute;
  top: 5px;
  right: 0;
  width: 14px;
  height: 14px;
}

.image_cover_box {
  display: flex;
  flex-wrap: wrap;
  margin-top: 12px;
  gap: 6px;
}

.submit_body .image_cover {
  width: 100px;
  height: 100px;
  border-radius: 6px;
  object-fit: cover;
  display: block;
}

.submit_body /deep/.el-textarea__inner {
  border: 0 !important;
  border-radius: 6px !important;
  background-color: #f3f5f8 !important;
  padding: 12px;
}

/deep/.el-upload--picture-card,
/deep/.el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
  line-height: 106px;
}

.submit_body .zhezhaoceng6 {
  position: absolute;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  opacity: 0;
}

.submit_body .zhezhaoceng6:hover {
  opacity: 1 !important;
}

.upload_img_wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.handle_more {
  position: relative;
  width: calc(100% - 120px);
  display: flex;
  align-items: center;
}

.handle_more > div {
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  margin-right: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.icon_emoji,
.icon_img,
.icon_topic,
.icon_pinzhong {
  width: 20px;
  height: 20px;
  display: block;
  margin-right: 2px;
}

.topic_list {
  position: absolute;
  top: 30px;
  left: 0;
  width: 310px;
  height: 350px;
  background: #ffffff;
  border-radius: 9px;
  border: 1px solid #dcdcdc;
  z-index: 2;
}

.topic_list .head {
  width: 100%;
  font-size: 14px;
  font-weight: bold;
  color: #3b3b3b;
  box-sizing: border-box;
  padding: 7px 10px;
  height: 70px;
}

.topic_list .head /deep/.el-input__inner {
  height: 32px;
  line-height: 32px;
  border-radius: 13px;
  background-color: #f3f5f8;
}

.topic_input /deep/.el-input__suffix {
  display: flex;
  align-items: center;
}

.topic_cells {
  height: calc(100% - 70px);
}

.topic_cell {
  box-sizing: border-box;
  padding: 0 20px;
  font-size: 14px;
  font-weight: 400;
  color: #6f6f6f;
}

.topic_cell > div {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  padding: 10px 0 10px 38px;
}

.topic_cell:not(:last-child) > div {
  border-bottom: 1px solid #e5e5e5;
}

.topic_cell img {
  position: absolute;
  top: 10px;
  left: 0;
  width: 25px;
  height: 25px;
  display: inline-block;
  border-radius: 1px;
  flex-shrink: 0;
  object-fit: cover;
}

.topic_cell span {
  box-sizing: border-box;
  margin-top: 3px;
  word-break: break-all;
  line-height: 25px;
}

.topic_cell .btn {
  width: 57px;
  height: 19px;
  border-radius: 15px;
  border: 1px solid #4571e7;
  font-size: 12px;
  font-weight: 400;
  color: #4571e7;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: absolute;
  top: 10px;
  right: 0;
}

.topic_cell:hover {
  background-color: #dde5fb;
  color: #4571e7;
}

.category_list {
  position: absolute;
  top: 30px;
  left: 0;
  width: 235px;
  height: 350px;
  background: #ffffff;
  border-radius: 9px;
  border: 1px solid #dcdcdc;
  z-index: 2;
}

.category_list .head {
  width: 100%;
  font-size: 14px;
  font-weight: bold;
  color: #3b3b3b;
  box-sizing: border-box;
  padding: 7px 10px;
  height: 70px;
}

.category_list .head /deep/.el-input__inner {
  height: 32px;
  line-height: 32px;
  border-radius: 13px;
  background-color: #f3f5f8;
}

.category_input /deep/.el-input__suffix {
  display: flex;
  align-items: center;
}

.category_cells {
  height: calc(100% - 70px);
}

.category_cell {
  box-sizing: border-box;
  padding: 0 20px;
  font-size: 14px;
  font-weight: 400;
  color: #6f6f6f;
}

.category_cell > div {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  padding: 10px 0;
}

.category_cell:not(:last-child) > div {
  border-bottom: 1px solid #e5e5e5;
}

.category_cell img {
  position: absolute;
  top: 10px;
  left: 0;
  width: 25px;
  height: 25px;
  display: inline-block;
  border-radius: 1px;
  flex-shrink: 0;
  object-fit: cover;
}

.category_cell span {
  box-sizing: border-box;
  margin-top: 3px;
  word-break: break-all;
  line-height: 25px;
}

.category_cell .btn {
  width: 57px;
  height: 19px;
  border-radius: 15px;
  border: 1px solid #4571e7;
  font-size: 12px;
  font-weight: 400;
  color: #4571e7;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: absolute;
  top: 10px;
  right: 0;
}

.category_cell:hover {
  background-color: #dde5fb;
  color: #4571e7;
}

.btn1 {
  width: 56px;
  height: 26px;
  border-radius: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 400;
  box-sizing: border-box;
  cursor: pointer;
  color: #ffffff;
  background-color: #4571e7;
}

.switch_text {
  font-weight: 400;
  font-size: 13px;
  color: #999999;
  margin-right: 15px;
  display: flex;
  align-items: center;
}

.switch_text span {
  margin-left: 6px;
}

.icon_tips {
  width: 14px;
  height: 14px;
  display: block;
  margin-left: 2px;
  cursor: pointer;
}

.input_number {
  display: flex;
  align-items: center;
}

.input_number span {
  font-weight: 400;
  font-size: 13px;
  color: #999999;
  margin-right: 7px;
}

.submit_tip {
  font-weight: 400;
  font-size: 12px;
  color: #f3920a;
  display: flex;
  align-items: center;
}

.submit_tip img {
  width: 14px;
  height: 14px;
  display: block;
  margin-right: 4px;
}
</style>
